export const mobileWidth = 576;

export const DEFAULT_WIDTH = 1024;